import type { TestSingleChoiceSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { outlineStyles } from 'components/Editor/styled/Outline'
import { border } from 'services/Branding/common.styled'
import type { ElementStyleCss } from 'services/Branding/types'

import MarkStyled from './MarkStyled'

const RadioLabelStyled = styled.label<{
  $styles: ElementStyleCss<TestSingleChoiceSchemaType>
  $disabled?: boolean
}>`
  position: relative;
  display: flex;
  max-width: 100%;
  align-items: center;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
  padding: ${({ $styles }) => $styles.text.padding};
  ${({ $styles }) => border($styles.border)}
  background-color: ${({ $styles }) => $styles?.item?.backgroundColor};
  box-shadow: ${({ $styles }) => $styles?.effects?.boxShadow};
  input {
    top: 0;
    left: 0;
    position: absolute;
    width: 0;
    height: 0;
    cursor: pointer;
    opacity: 0;
  }
  &:hover {
    background-color: ${({ $styles }) => $styles.item_hover.backgroundColor};
  }

  &:hover ${MarkStyled} {
    border-color: ${({ $disabled, $styles }) => !$disabled && $styles.radio.color};
  }

  &:has(input:focus-visible) {
    ${outlineStyles}

    background-color: ${({ $styles }) => $styles.item_hover.backgroundColor};
    & ${MarkStyled} {
      border-color: ${({ $disabled, $styles }) => !$disabled && $styles.radio.color};
    }
  }
`

export default RadioLabelStyled
